import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './_directives/modal.component';
import { ErrorService } from './_services/error.service';

import { OrderByPipe } from './_pipes/order-by-pipe';
import { RouterModule } from '@angular/router';
import { ModalKcsModule } from '../_directives/modal/kcs-modal.module';
import { ConfigService } from '../_services/config.service';

@NgModule({
	imports: [RouterModule, CommonModule, FormsModule, ReactiveFormsModule, ModalKcsModule],
	declarations: [ModalComponent, OrderByPipe],
	providers: [
		ErrorService,
		{
			provide: APP_INITIALIZER,
			useFactory: (configService: ConfigService) =>
				function () {
					return configService.load();
				},
			deps: [ConfigService],
			multi: true,
		},
	],
	exports: [ModalComponent, OrderByPipe],
	bootstrap: [ModalComponent],
})
export class SharingModule {}
